// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SupportContent .faq {
  margin-bottom: 20px;
}

.SupportContent section {
  margin-bottom: 21px;
}

.SupportContent section h4 {
  color: #37B4C9;
  margin-bottom: 4px;
}

.SupportContent section p {
  font-size: 15px;
  line-height: 1.4em;
}

.SupportContent section li {
  -webkit-font-smoothing: antialiased;
  margin-bottom: 0px;
  line-height: 19px;
}

.SupportSidebar a {
  color: #32445A;
}

.Breadcrumb {
  font-size: 22px;
  font-weight: 300;
}

.Breadcrumb a {
  color: #32445A;
}

.BreadcrumbContainer {
  background: #EFF1F3;
  padding: 25px 0 25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/support/support.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".SupportContent .faq {\n  margin-bottom: 20px;\n}\n\n.SupportContent section {\n  margin-bottom: 21px;\n}\n\n.SupportContent section h4 {\n  color: #37B4C9;\n  margin-bottom: 4px;\n}\n\n.SupportContent section p {\n  font-size: 15px;\n  line-height: 1.4em;\n}\n\n.SupportContent section li {\n  -webkit-font-smoothing: antialiased;\n  margin-bottom: 0px;\n  line-height: 19px;\n}\n\n.SupportSidebar a {\n  color: #32445A;\n}\n\n.Breadcrumb {\n  font-size: 22px;\n  font-weight: 300;\n}\n\n.Breadcrumb a {\n  color: #32445A;\n}\n\n.BreadcrumbContainer {\n  background: #EFF1F3;\n  padding: 25px 0 25px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
